module.exports = __webpack_public_path__ + "static/media/LG 11_18sec.f03de62a.mp3";